/* import __COLOCATED_TEMPLATE__ from './company-profile-brands-list-item.hbs'; */
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { enqueueTaskGroup, task } from 'ember-concurrency';
import { inject as service } from '@ember/service';
import { action } from '@ember/object';
import { showModal } from 'sh-www/utils/modal-controls';

const CLASS_NAME = 'SH-c-company-profile-brands-list-item';

class CompanyProfileBrandsListItem extends Component {
  @service('commands.brand-commands') brandCommandService;
  @service('state-managers/application') applicationStateManager;
  @service('commands/image-commands') imageCommandService;
  @service ('error-tracker') errorTracker;
  @service session;

  @enqueueTaskGroup updateBrandGroup;

  @tracked isEditing = false;

  get className() {
    return CLASS_NAME;
  }

  get menuTeamOptions() {
    const { companyTeams, canEditBrands } = this.args;
    const menuOptions = [];

    if (!canEditBrands || !companyTeams.length) {
      return menuOptions;
    }

    companyTeams.forEach((team) => {
      menuOptions.push({
        title: team.name,
        onClick: () => this.addBrandCompenyTeam.perform(team),
      });
    });

    return menuOptions;
  }

  get menuAdditionalOptions() {
    const { canEditBrands } = this.args;
    const menuOptions = [];

    if (canEditBrands) {
      menuOptions.push({
        title: 'Edit',
        onClick: () => this.isEditing = true,
      });

      menuOptions.push({
        title: 'Delete',
        onClick: this.onDeleteBrandClicked,
      });
    }

    return menuOptions;
  }

  @task({ group: 'updateBrandGroup' })
  *addBrandCompenyTeam(team) {
    const { brand } = this.args;

    try {
      yield this.brandCommandService.storeBrandCompanyTeam(brand.id, team.id);
      yield this.args.loadBrand.perform(brand.id);
    } catch (error) {
      this.applicationStateManager.addToast('Failed to add team to brand');
      this.errorTracker.error(`addBrandCompenyTeam - failed to add team id ${team.id} to brand id ${brand.id}`, this, error);
    }
  }

  @task({ group: 'updateBrandGroup' })
  *removeBrandCompanyTeam(team) {
    const { brand } = this.args;

    try {
      yield this.brandCommandService.destroyBrandCompanyTeam(brand.id, team.id);
      yield this.args.loadBrand.perform(brand.id);
    } catch (error) {
      this.applicationStateManager.addToast('Failed to remove team from brand');
      this.errorTracker.error(`removeBrandCompanyTeam - failed to remove team id ${team.id} from brand id ${brand.id}`, this, error);
    }
  }

  @task({ group: 'updateBrandGroup' })
  *updateBrand(name, isThirdParty, image) {
    const { brand, updateBrandInArray } = this.args;

    try {
      if (image !== brand.image) {
        yield this.imageCommandService.associateImage(image, brand);
      }

      const reloadedBrand = yield this.brandCommandService.updateBrand(brand.id, name, isThirdParty);
      updateBrandInArray(reloadedBrand);
      this.cancelEditBrand();
    } catch (error) {
      this.applicationStateManager.addToast('Failed to update brand');
      this.errorTracker.error(`updateBrand - failed to update brand id ${brand.id}`, this, error);
    }
  }

  @task({ group: 'updateBrandGroup' })
  *deleteBrand() {
    const { brand, removeBrandFromArray } = this.args;

    try {
      yield this.brandCommandService.destroyBrand(brand.id);
      removeBrandFromArray(brand.id);
    } catch (error) {
      this.applicationStateManager.addToast('Failed to delete brand');
      this.errorTracker.error(`deleteBrand - failed to delete brand id ${brand.id}`, this, error);
    }
  }

  @action
  onDeleteBrandClicked() {
    const modalModel = {
      titleText: 'Delete Brand?',
      bodyText: 'This brand will be removed from all of your postings and projects for the associated teams and will be replaced with your company branding.',
      actionButtonText: 'Delete',
      cancelButtonText: 'Nevermind',
      isShowCancelButton: true,
      confirmAction: () => {
        this.deleteBrand.perform();
      }
    };

    showModal(this, 'confirmation', modalModel);
  }

  @action
  cancelEditBrand() {
    this.isEditing = false;
  }
}

export default CompanyProfileBrandsListItem;
